<template>
  <div class="zixunxiangqinmg">
    <!-- 头部 -->
    <div class="new_top">
      <header2></header2>
      <navigation></navigation>
    </div>

    <div class="sy_main">
      <div class="sy_position">您当前的位置：<a href="#">首页</a> &gt;&gt; 资讯详情</div>
      <div class="sym_content2">
        <div class="symc3">
          <div class="symc3_main">
            <div class="symc3_box">
              <div class="symc3_box_title">
                <p class="detail_title">{{newsInfo.newsTitle}}</p>
                <p class="detail_info"><span>来源：{{newsInfo.newsSource}}</span><span>发布日期：{{newsInfo.publishTime}}</span><a href="javascript:;" onClick="window.print();">【打印本页】</a></p>
              </div>
              <div class="symc3_box_main" style="min-height: 200px;">
                <!--此DIV内放编辑器发布的新闻内容-->
                <div v-html="newsInfo.content"></div>
              </div>
              <!--<div class="symc2_box">
                <div class="symc2_box_title" style="padding-left: 10px;"><a href="javascript:;">其他文章</a></div>
                <div class="symc2_box_main">
                  <ul>
                    <li><a href="" title="十堰市第四周期医师定期考核工作启动暨培训会在市学会办召开">上一篇：十堰市第四周期医师定期考核工作启动暨培训会在市学会办召开</a></li>
                    <li><a href="" title="十堰市第四周期医师定期考核工作启动暨培训会在市学会办召开">下一篇：十堰市第四周期医师定期考核工作启动暨培训会在市学会办召开</a></li>
                  </ul>
                </div>
              </div>-->
            </div>
          </div>
        </div>
        <!--右侧1竖模块-->
        <div class="symc_right">
          <login></login>
          <latestNewsSimple></latestNewsSimple>
        </div>
      </div>
      <div class=""></div>
    </div>
    <footer1></footer1>
  </div>
</template>

<script>
  import {getNews} from '../api/api';
  import  header2 from '../components/Header2'
  import  footer1 from '../components/Footer1'
  import  login from '../components/Login'
  import  latestNewsSimple from '../components/LatestNewsSimple'
  import  navigation from '../components/Navigation'
  export default {
    components: {
      header2,
      navigation,
      footer1,
      login,
      latestNewsSimple
    },
    data () {
      return {
        newsInfo: {}
      }
    },
    mounted () {
      getNews({
        id: this.$route.query.id
      }).then((response) => {
        this.newsInfo = response.data.data.newsInfo;
        document.title="资讯详情-"+this.newsInfo.newsTitle
      })
    },
    computed: {},
    methods: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/NewsInfo.vue